import { type Job, type JobServer } from "@/types/file";
import { type FileMetadata, type FileMetadataServer } from "@/types/jobFileUpload";
import { type PreprocessingWorkflowServer } from "@/types/workflow";

import { convertPreprocessingWfToServer, normalizeWf } from "./workflow";

export const transformJobServerToJob = (job: JobServer): Job => {
  return {
    ...job,
    workflow: normalizeWf(job.workflow),
  };
};

export const convertFileMetadataToServer = (fileMetadata: FileMetadata): FileMetadataServer => {
  return {
    original_name: fileMetadata.originalName,
    pages: fileMetadata.pages,
    pages_to_process: fileMetadata.pagesToProcess,
    custom_config: convertPreprocessingWfToServer(fileMetadata.customConfig) as PreprocessingWorkflowServer,
    new_file_name: fileMetadata.newFileName,
  };
};
